module.exports = __webpack_public_path__ + "static/media/blog-5.b69dd3dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-5.jpg
// module id = 846
// module chunks = 0